import { h } from 'preact';
import * as BaseComp from 'components/pages/synopsis/synopsis.js';
// import s from 'components/pages/synopsis/synopsis.sss';

export default class Synopsis extends BaseComp.default {
	getExtraContent() {
		console.log('this: ', this.props.pageData)
		return <img src="//s3-eu-west-1.amazonaws.com/st-static-stage/greenwichentertainment/itzhak/images/laurrels.png" />
	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
